import React from "react";
import Window from "./Window";

import "./ProvablyFair.css";

export default class ProvablyFair extends React.Component<ProvablyFair.Props, ProvablyFair.State>
{


    constructor(props: ProvablyFair.Props)
    {
        super(props);
    }

    
    render()
    {
        const lang = window.lang.shared.modals["provably-fair"];
        const lShared = window.lang.shared;

        return (
            <Window
                title={lShared.what_is_provably_fair + "?"}
                id="provablyFair"
            >
                <div className="logo">
                    <div className="icon_fair"></div>
                    <div className="slogan">
                        Provably Fair - {lang["slogan"]}
                    </div>
                </div>
                <div className="content">

                    <div className="bordered">
                        {lang["top text"]}
                    </div>

                    <h1>
                        {lang["How does it work"]}
                    </h1>

                    <h2>
                        {lang.Simple}
                    </h2>
                    <p>
                        {lang.text1}
                    </p>
                    
                    <h2>
                        {lang["more"]}
                    </h2>
                    <p>
                        {lang["text2-1"] + " "}
                        <span className="darker">
                            {lang["text2-2"] + " "}
                        </span>
                        {lang["text2-3"]}
                    </p>
                    <p>
                        {lang["text2-4"]}
                    </p>

                    <div className="image_1"></div>

                    <h1>
                        {lang["video title"]}
                    </h1>

                    <div className="how-to">
                        <p> - {lang["stats-1"]}</p>
                        <p> - {lang["stats-2"]}</p>
                        <p> - {lang["settings-1"]} {lang["settings-2"]}</p>
                        <p> - {lang["settings-3"]}</p>
                    </div>

                </div>
            </Window>
        );
    }


}

export namespace ProvablyFair
{


    export interface Props
    {
        
    }


    export interface State
    {

    }


}